var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-table",
    {
      staticStyle: { width: "100%" },
      attrs: {
        border: "",
        "header-cell-style": {
          backgroundColor: "#FDEFE7",
          color: "#000000",
        },
        data: _vm.tableData,
      },
    },
    [
      _c("el-table-column", {
        attrs: {
          align: "center",
          prop: "date",
          label: "订单状态",
          width: "180",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return _vm._l(scope.row.statusDescription, function (n, m) {
                return _c(
                  "div",
                  {
                    key: m,
                    staticStyle: {
                      "font-size": "0.12rem",
                      "margin-bottom": "0.05rem",
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: { color: "red", "margin-right": "0.2rem" },
                      },
                      [_vm._v(_vm._s(n.statusText))]
                    ),
                    _c("span", { staticStyle: { color: "#3A8477" } }, [
                      _vm._v(_vm._s(n.num) + "个子订单"),
                    ]),
                  ]
                )
              })
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          align: "center",
          prop: "name",
          label: "操作时间",
          width: "180",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _vm._v(
                  " " +
                    _vm._s(_vm._f("dateFormatHms")(scope.row.createTime)) +
                    " "
                ),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          align: "center",
          prop: "address",
          label: "操作",
          width: "180",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }